/**
 * 复制文本到剪贴板
 * @param text 待复制的文本
 */
export function copy(text: string): void {

    const input = document.createElement('input');
    const body = document.getElementsByTagName('body')[0];
    input.value = text;
    body.appendChild(input);
    input.select();
    document.execCommand('copy');
    body.removeChild(input);
}

/**
 * 使用 navigator.clipboard 方法复制文本
 * 失败则降级使用document.execCommand
 * @param text 
 */
export async function copyByClipboard(text: string): Promise<void> {
    try {
        await  navigator.clipboard.writeText(text);
        console.error('Not Support navigator.clipboard');
    }
    catch {
        copy(text);
    }
    
}
